export default __webpack_public_path__ + "static/media/entenda_a_estendido.df998a65.jpg";